// Tablas del MCP de empresa (docs/analisis-mcp-empresa.md): tokens de
// administrador para agentes de IA y el registro de sus llamadas. Solo
// definiciones: la importa `schema.ts` y el dominio `mcp`.

import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";

export const mcpConfirmPolicy = v.union(v.literal("confirm_live"), v.literal("direct"));

export const validatorMcpToken = v.object({
  name: v.string(),
  /** Dueño: las llamadas corren con su contexto y sus permisos. */
  userId: v.id("users"),
  scopes: v.array(v.string()),
  confirmPolicy: mcpConfirmPolicy,
  /** SHA-256 (hex) del token completo; el token se muestra una vez. */
  tokenHash: v.string(),
  tokenHint: v.string(),
  expiresAt: v.optional(v.number()),
  revokedAt: v.optional(v.number()),
  lastUsedAt: v.optional(v.number()),
  /** `clientInfo` que mando el agente en `initialize` (p. ej. "claude-code 2.1"). */
  lastClient: v.optional(v.string()),
  callCount: v.number(),
  internalControl,
});

export const mcp_tokens = defineTable(validatorMcpToken)
  .index("by_company", ["internalControl.companyId"])
  .index("by_user", ["userId"]);

/** Una fila por llamada (sin argumentos ni resultados). Se purga a los 30 dias. */
export const mcp_calls = defineTable({
  tokenId: v.id("mcp_tokens"),
  companyId: v.id("companies"),
  method: v.string(),
  tool: v.optional(v.string()),
  ok: v.boolean(),
  error: v.optional(v.string()),
  durationMs: v.number(),
  at: v.number(),
})
  .index("by_token_and_at", ["tokenId", "at"])
  .index("by_company_and_at", ["companyId", "at"])
  .index("by_at", ["at"]);

/**
 * Confirmaciones de dos pasos (politica `confirm_live`): una herramienta que
 * cambia lo vigente devuelve un `confirmToken` (id de esta fila) y solo se
 * ejecuta si se vuelve a llamar con los mismos argumentos y ese token, antes
 * de que venza y una sola vez.
 */
export const mcp_confirmations = defineTable({
  tokenId: v.id("mcp_tokens"),
  tool: v.string(),
  /** SHA-256 de los argumentos (sin `confirmToken`), en JSON canonico. */
  argsHash: v.string(),
  summary: v.string(),
  expiresAt: v.number(),
  usedAt: v.optional(v.number()),
})
  .index("by_token", ["tokenId"])
  .index("by_expires_at", ["expiresAt"]);
